import React from "react";
import { useSelector, useDispatch } from "react-redux";

export default function FlightIataFilter(props) {
  const { baggage, setBaggage, filterAirlines, setFilterAirlines } = props;
  const fares = useSelector((state) => state.flight.fares);
  const offers = useSelector((state) => state.flight.offers);

  let airlines = {};
  if (offers?.length > 0) {
    for (let i = 0; i < offers.length; i++) {
      if (
        airlines[
          offers[i].OfferServices?.Package?.Flight?.OutboundFlight?.Airline
            ?.AirlineCode
        ]
      ) {
        airlines[
          offers[
            i
          ].OfferServices?.Package?.Flight?.OutboundFlight?.Airline?.AirlineCode
        ] = {
          ...airlines[
            offers[i].OfferServices?.Package?.Flight?.OutboundFlight?.Airline
              ?.AirlineCode
          ],
          count:
            airlines[
              offers[i].OfferServices?.Package?.Flight?.OutboundFlight?.Airline
                ?.AirlineCode
            ].count + 1,
        };
      } else {
        airlines[
          offers[
            i
          ].OfferServices?.Package?.Flight?.OutboundFlight?.Airline?.AirlineCode
        ] = {
          ...offers[i].OfferServices?.Package?.Flight?.OutboundFlight?.Airline,
          count: 1,
        };
      }
    }
  }
  console.log(airlines);

  return (
    <div className="pricefilter">
      <div className="pricefilter1 filterheader">Filter</div>
      <br />
      {/*<div className="filterrow">
        <div className="filter1">
          <input
            className="boardtypefilter4"
            checked={false}
            onChange={() => {}}
            disabled={false}
            type="checkbox"
          />
        </div>
        <div className="filter2">
          {"inkl. Handgepäck " +
            "(" +
            offers.filter((o, i) => {
              return (
                o?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
                  ?.FlightSegment[0]?.BaggageAllowance?.value != "0K" &&
                o?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
                  ?.FlightSegment[0]?.BaggageAllowance?.value != "0PC"
              );
            }).length +
            ")"}
        </div>
      </div>*/}
      <div className="filterrow">
        <div className="filter1">
          <input
            className="boardtypefilter4"
            //aktuell nur eine möglichkeit, offen für mehr optionen
            checked={baggage}
            onChange={() => {
              setBaggage(!baggage);
            }}
            type="checkbox"
          />
        </div>
        <div className="filter2">
          {"inkl. Aufgabegepäck " +
            "(" +
            offers.filter((o, i) => {
              if (
                o?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
                  ?.FlightSegment[0]?.BaggageAllowance?.value
              ) {
                //console.log(o?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments?.FlightSegment[0]?.BaggageAllowance);
              }
              return (
                o?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
                  ?.FlightSegment[0]?.BaggageAllowance?.value != "0K" &&
                o?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
                  ?.FlightSegment[0]?.BaggageAllowance?.value != "0PC"
              );
            }).length +
            ")"}
        </div>
      </div>
      <br />
      <br />
      <div className="pricefilter1 filterheader">Fluggesellschaften</div>
      <br />
      {Object.keys(airlines)
        .sort((a, b) => {
          if (airlines[a]["AirlineName"] < airlines[b]["AirlineName"]) {
            return -1;
          } else {
            return 1;
          }
        })
        .map((o, i) => {
          return (
            <div className="filterrow">
              <div className="filter1">
                <input
                  className="boardtypefilter4"
                  checked={filterAirlines.includes(o)}
                  onChange={() => {
                    if (filterAirlines.includes(o)) {
                      console.log("here1");
                      let tmp = [...filterAirlines];
                      let index = tmp.indexOf(o);
                      tmp.splice(index, 1);
                      setFilterAirlines(tmp);
                    } else {
                      console.log("here2");
                      console.log(o);
                      let tmp = [...filterAirlines];
                      tmp.push(o);
                      setFilterAirlines(tmp);
                    }
                  }}
                  disabled={false}
                  type="checkbox"
                />
              </div>
              <div className="filter2">
                {airlines[o].AirlineName + " (" + airlines[o].count + ")"}
              </div>
            </div>
          );
        })}
    </div>
  );
}
